export default "__VITE_ASSET__$vV2Ks$T__"